"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = /(chrome|moz|safari)-extension|recaptcha|webkit-masked-url:\/\/hidden/i;
//# sourceMappingURL=ignoredStack.js.map